<template>
  <div class="flex-shrink-0 flex items-center bg-blue-500 text-white top-bar">
    <div class="w-16 mr-auto">
      <div
        @click="goBack"
        class="flex p-4 cursor-pointer"
        v-if="showBackButton"
      >
        <ion-icon name="arrow-back-sharp" class="fs-3 text-white" />
      </div>
    </div>

    <router-link to="/" class="p-4">
      <img :src="logo" class="h-8" />
    </router-link>

    <div class="flex justify-end w-16 ml-auto">
      <router-link to="/settings" class="flex p-4 cursor-pointer">
        <ion-icon name="settings-sharp" class="fs-3 text-white" />
      </router-link>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/logo.png";

import router from "@/router/index";

export default {
  name: "TopBar",
  data() {
    return {
      logo,
    };
  },
  computed: {
    abc() {
      return this.$route.path;
    },
    showBackButton() {
      return this.$route.fullPath !== "/";
    },
  },
  methods: {
    goBack() {
      router.back();
    },
  },
};
</script>

<style lang="scss">
.top-bar {
  a {
    text-decoration: none;
  }
}
</style>
